import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useFiltersStore = defineStore('filters', () => {
  // State
  const searchQuery = ref('')
  const selectedCategory = ref('')
  const selectedLabels = ref([])
  const isFiltering = ref(false)

  // Getters
  const hasActiveFilters = computed(() => {
    return searchQuery.value || selectedCategory.value || selectedLabels.value.length > 0
  })

  const filterParams = computed(() => {
    const params = {}
    
    if (searchQuery.value) {
      params.search = searchQuery.value
    }
    
    if (selectedCategory.value) {
      params.category = selectedCategory.value
    }
    
    if (selectedLabels.value.length > 0) {
      params.labels = selectedLabels.value.join(',')
    }
    
    return params
  })

  // Actions
  const setSearch = (query) => {
    searchQuery.value = query
    isFiltering.value = hasActiveFilters.value
  }

  const setCategory = (category) => {
    selectedCategory.value = category
    isFiltering.value = hasActiveFilters.value
  }

  const setLabels = (labels) => {
    selectedLabels.value = Array.isArray(labels) ? labels : []
    isFiltering.value = hasActiveFilters.value
  }

  const addLabel = (labelId) => {
    if (!selectedLabels.value.includes(labelId)) {
      selectedLabels.value.push(labelId)
      isFiltering.value = hasActiveFilters.value
    }
  }

  const removeLabel = (labelId) => {
    const index = selectedLabels.value.indexOf(labelId)
    if (index > -1) {
      selectedLabels.value.splice(index, 1)
      isFiltering.value = hasActiveFilters.value
    }
  }

  const clearSearch = () => {
    searchQuery.value = ''
    isFiltering.value = hasActiveFilters.value
  }

  const clearCategory = () => {
    selectedCategory.value = ''
    isFiltering.value = hasActiveFilters.value
  }

  const clearLabels = () => {
    selectedLabels.value = []
    isFiltering.value = hasActiveFilters.value
  }

  const clearAllFilters = () => {
    searchQuery.value = ''
    selectedCategory.value = ''
    selectedLabels.value = []
    isFiltering.value = false
  }

  const setFilters = (filters) => {
    if (filters.search !== undefined) {
      searchQuery.value = filters.search
    }
    if (filters.category !== undefined) {
      selectedCategory.value = filters.category
    }
    if (filters.labels !== undefined) {
      selectedLabels.value = Array.isArray(filters.labels) ? filters.labels : []
    }
    isFiltering.value = hasActiveFilters.value
  }

  const reset = () => {
    clearAllFilters()
  }

  return {
    // State
    searchQuery,
    selectedCategory,
    selectedLabels,
    isFiltering,
    
    // Getters
    hasActiveFilters,
    filterParams,
    
    // Actions
    setSearch,
    setCategory,
    setLabels,
    addLabel,
    removeLabel,
    clearSearch,
    clearCategory,
    clearLabels,
    clearAllFilters,
    setFilters,
    reset
  }
})
